import { c as _c } from "react/compiler-runtime";
import { HotelSortViewPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view/hotel-sort-view.types";
import { MaterialIcon } from "@website/icons/material";
import toString from "lodash-es/toString";
import { useEffect, useState } from "react";
export const useHotelSortView = properties => {
  const $ = _c(30);
  const {
    list,
    initialValue,
    popoverProps,
    buttonProps,
    onChange
  } = properties;
  const [isDirty, setIsDirty] = useState(false);
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState();
  let t0;
  let t1;
  if ($[0] !== initialValue || $[1] !== list) {
    t0 = () => {
      setResult(list.find(item => item.value === (initialValue || "selling")));
    };
    t1 = [initialValue, list];
    $[0] = initialValue;
    $[1] = list;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpen(true);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onClickChips = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setOpen(false);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onClosePopover = t3;
  let t4;
  if ($[6] !== list || $[7] !== onChange) {
    t4 = response => {
      const item_0 = list.find(element => element.value === response.target.value);
      setIsDirty(true);
      setResult(item_0);
      onChange?.(item_0?.value);
      onClosePopover();
    };
    $[6] = list;
    $[7] = onChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onChangeRadio = t4;
  let t5;
  if ($[9] !== initialValue || $[10] !== isDirty || $[11] !== result?.label) {
    t5 = () => toString(!isDirty && !initialValue ? "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC" : !isDirty && initialValue || isDirty ? result?.label : "");
    $[9] = initialValue;
    $[10] = isDirty;
    $[11] = result?.label;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const getLabelText = t5;
  let t6;
  if ($[13] !== getLabelText) {
    t6 = getLabelText();
    $[13] = getLabelText;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MaterialIcon className="text-sm" name="sort" />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== buttonProps || $[17] !== t6) {
    t8 = {
      size: "small" as const,
      children: t6,
      variant: "round-outline" as const,
      StartIcon: t7,
      color: "neutral" as const,
      onClick: onClickChips,
      ...buttonProps
    };
    $[16] = buttonProps;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== open || $[20] !== popoverProps) {
    t9 = {
      onClose: onClosePopover,
      open,
      title: "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC",
      defaultHorizontalPosition: "end" as const,
      ...popoverProps
    };
    $[19] = open;
    $[20] = popoverProps;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = result?.value;
  let t11;
  if ($[22] !== list || $[23] !== onChangeRadio || $[24] !== t10) {
    t11 = {
      list,
      checkedRadio: t10,
      onChangeRadio
    };
    $[22] = list;
    $[23] = onChangeRadio;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t8 || $[28] !== t9) {
    t12 = {
      buttonProps: t8,
      popoverProps: t9,
      radioProps: t11
    };
    $[26] = t11;
    $[27] = t8;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};